const CypressTestIds = {
    // Toast Messages
    TOAST_ALERT_MESSAGE_SUCCESS: "toast-alert-message-success",
    TOAST_ALERT_MESSAGE_ERROR: "toast-alert-message-error",
    TOAST_ALERT_MESSAGE_WARNING: "toast-alert-message-warning",
    TOAST_ALERT_MESSAGE_INFO: "toast-alert-message-info",

    // HeaderMenu
    HEADER_MENU_HOME: "header-menu-home",
    HEADER_MENU_SCHEMA: "header-menu-schema",
    HEADER_MENU_RELATIONSHIPS: "header-menu-relationships",
    HEADER_MENU_VIEWS: "header-menu-views",
    HEADER_MENU_SEARCH: "header-menu-search",
    HEADER_MENU_SEARCH_DUPLICATE: "header-menu-search-duplicate",
    HEADER_MENU_CONFIGURATION: "header-menu-configuration",
    HEADER_MENU_BUSINESS_AREA_SELECT_MENU_BUTTON: "header-menu-business-area-select-menu-button",
    HEADER_MENU_BUSINESS_AREA_SELECT_MENU: "header-menu-business-area-select-menu",

    // Configuration > VerticleMenuContent
    // NOTE: This is generated automatically for all menus
    VERTICAL_MENU_BUSINESSAREAS: "vertical-menu-configuration-businessareas",
    VERTICAL_MENU_BUSINESSAREADATA: "vertical-menu-configuration-businessareadata",
    VERTICAL_MENU_DATACLASSIFIERS: "vertical-menu-configuration-dataclassifiers",
    VERTICAL_MENU_ROLES: "vertical-menu-configuration-roles",
    VERTICAL_MENU_USERS: "vertical-menu-configuration-users",
    VERTICAL_MENU_API_KEYS: "vertical-menu-configuration-apikeys",
    VERTICAL_MENU_SYSTEMCONNECTIONS: "vertical-menu-configuration-systemconnections",
    VERTICAL_MENU_SYSTEMKEYS: "vertical-menu-configuration-systemkeys",
    VERTICAL_MENU_CHANGEDATACAPTURE: "vertical-menu-configuration-changedatacapture",
    VERTICAL_MENU_TENANCYCUSTOMIZATION: "vertical-menu-configuration-tenancycustomization",

    // OkCancelConfirmationBox
    CONFIRMATION_BOX_OK_BUTTON: "confirmation-box-ok-button",
    CONFIRMATION_BOX_CANCEL_BUTTON: "confirmation-box-cancel-button",

    // User Login
    USER_LOGIN_EMAIL_LINK_SENT_MESSAGE: "user-login-email-link-sent-message",
    USER_LOGIN_EMAIL_INPUT: "user-login-email-input",
    USER_LOGIN_PASSWORD_INPUT: "user-login-password-input",
    USER_LOGIN_SUBMIT_BUTTON: "user-login-submit-button",
    USER_LOGIN_FORGOT_PASSWORD_LINK: "user-login-forgot-password-link",
    USER_LOGIN_RESEND_VERIFY_EMAIL_LINK: "user-login-resend-verify-email-link",
    USER_LOGIN_NEW_USER_RADIO: "user-login-new-user-radio",
    USER_LOGIN_EXISTING_USER_RADIO: "user-login-existing-user-radio",

    // Reset Password
    USER_RESET_PASSWORD_BACKTOLOGIN_BUTTON: "user-reset-password-backtologin-button",
    USER_RESET_PASSWORD_FORM: "user-reset-password-form",
    USER_RESET_PASSWORD_EMAIL_INPUT: "user-reset-password-email-input",
    USER_RESET_PASSWORD_SUBMIT_BUTTON: "user-reset-password-submit-button",
    USER_RESET_PASSWORD_EMAIL_ERROR_MESSAGE: "user-reset-password-email-error-message",
    USER_RESET_PASSWORD_LINK_SENT_MESSAGE: "user-reset-password-link-sent-message",

    // Signup
    USER_SIGNUP_CORPORATE_EMAIL_INPUT: "user-signup-corporate-email-input",
    USER_SIGNUP_PASSWORD_INPUT: "user-signup-password-input",
    USER_SIGNUP_FIRST_NAME_INPUT: "user-signup-first-name-input",
    USER_SIGNUP_LAST_NAME_INPUT: "user-signup-last-name-input",
    USER_SIGNUP_AGREE_TERMS_CHECKBOX: "user-signup-agree-terms-checkbox",
    USER_SIGNUP_SIGNUP_BUTTON: "user-signup-signup-button",
    USER_SIGNUP_GOBACKTOLOGIN_BUTTON: "user-signup-gobacktologin-button",

    // Change Password
    USER_CHANGE_PASSWORD_INPUT: "user-change-password-input",
    USER_CHANGE_PASSWORD_CONFIRM_INPUT: "user-change-password-confirm-input",
    USER_CHANGE_PASSWORD_SUBMIT_BUTTON: "user-change-password-submit-button",
    USER_CHANGE_PASSWORD_ERROR_MESSAGE: "user-change-password-error-message",
    USER_CHANGE_PASSWORD_SUCCESS_MESSAGE: "user-change-password-success-message",

    // BusinessAreaList
    ADD_BUSINESS_AREA_BUTTON: "add-business-area-button",
    DELETE_BUSINESS_AREA_BUTTON: "delete-business-area-button",
    EDIT_BUSINESS_AREA_BUTTON: "edit-business-area-button",
    VIEW_BUSINESS_AREA_BUTTON: "view-business-area-button",
    HISTORY_BUSINESS_AREA_BUTTON: "history-business-area-button",
    ACTIVATE_BUSINESS_AREA_SWITCH: "activate-business-area-switch",

    // ManageBusinessArea
    MANAGE_BUSINESS_AREA_NAME_INPUT: "manage-business-area-name-input",
    MANAGE_BUSINESS_AREA_DESCRIPTION_INPUT: "manage-business-area-description-input",
    MANAGE_BUSINESS_AREA_SAVE_BUTTON: "manage-business-area-save-button",
    MANAGE_BUSINESS_AREA_CANCEL_BUTTON: "manage-business-area-cancel-button",

    // ManageBusinessArea tabs
    MANAGE_BUSINESS_AREA_TAB_USER: "manage-business-area-tab-user",
    MANAGE_BUSINESS_AREA_TAB_CREDENTIALS: "manage-business-area-tab-credentials",
    MANAGE_BUSINESS_AREA_TAB_SYSTEM_CONNECTIONS: "manage-business-area-tab-system-connections",

    // BusinessAreaUserList
    BUSINESS_AREA_USER_SELECT: "business-area-user-select",
    ADD_BUSINESS_AREA_USER_BUTTON: "add-business-area-user-button",
    DELETE_BUSINESS_AREA_USER_BUTTON: "delete-business-area-user-button",
    ACTIVATE_BUSINESS_AREA_USER_CHECKBOX: "activate-business-area-user-checkbox",
    CAN_DELETE_BUSINESS_AREA_USER_CHECKBOX: "can-delete-business-area-user-checkbox",
    CAN_EDIT_BUSINESS_AREA_USER_CHECKBOX: "can-edit-business-area-user-checkbox",
    CAN_VIEW_BUSINESS_AREA_USER_CHECKBOX: "can-view-business-area-user-checkbox",
    CAN_ADD_BUSINESS_AREA_USER_CHECKBOX: "can-add-business-area-user-checkbox",

    //Business Area Client/Credentials list - Neeraj
    BUSINESS_AREA_CLIENT_LIST_SELECT: "business-area-client-list-select",
    BUSINESS_AREA_CLIENT_LIST_CAN_ADD_CHECKBOX: "business-area-client-list-can-add-checkbox",
    BUSINESS_AREA_CLIENT_LIST_CAN_VIEW_CHECKBOX: "business-area-client-list-can-view-checkbox",
    BUSINESS_AREA_CLIENT_LIST_CAN_EDIT_CHECKBOX: "business-area-client-list-can-edit-checkbox",
    BUSINESS_AREA_CLIENT_LIST_CAN_DEL_CHECKBOX: "business-area-client-list-can-del-checkbox",
    BUSINESS_AREA_CLIENT_LIST_ACTIVE_CHECKBOX: "business-area-client-list-active-checkbox",
    BUSINESS_AREA_CLIENT_LIST_DELETE_BUTTON: "business-area-client-list-delete-button",
    BUSINESS_AREA_CLIENT_ADD_BUTTON: "business-area-client-list-add-button",
    BUSINESS_AREA_CLIENT_LIST_TABLE: "business-area-client-list-table",

    //Business Area Data
    BUSINESS_AREA_DATA_LIST_TABLE: "business-area-data-list-table",
    BUSINESS_AREA_DATA_LIST_EDIT_BUTTON: "business-area-data-list-edit-button",
    BUSINESS_AREA_DATA_LIST_VIEW_BUTTON: "business-area-data-list-view-button",
    BUSINESS_AREA_DATA_LIST_VIEW_HISTORY_BUTTON: "business-area-data-list-view-history-button",
    BUSINESS_AREA_DATA_LIST_DELETE_BUTTON: "business-area-data-list-delete-button",

    BUSINESS_AREA_DATA_ADD_NEW_BUTTON: "business-area-data-add-new-button",
    MANAGE_BUSINESS_AREA_DATA_BUSINESS_AREA_NAME_SELECT: "manage-business-area-data-business-area-name-select",
    MANAGE_BUSINESS_AREA_DATA_DOMAIN_NAME_INPUT: "manage-business-area-data-domain-name-input",
    MANAGE_BUSINESS_AREA_DATA_DESCRIPTION_INPUT: "manage-business-area-data-description-input",
    MANAGE_BUSINESS_AREA_DATA_PURPOSE_INPUT: "manage-business-area-data-purpose-input",
    MANAGE_BUSINESS_AREA_DATA_DATA_TAGS_SELECT: "manage-business-area-data-tags-select",
    MANAGE_BUSINESS_AREA_DATA_FILE_INPUT: "manage-business-area-data-file-input",
    MANAGE_BUSINESS_AREA_DATA_REPLACE_DATA_OPTION: "manage-business-area-data-replace-existing-data-option",
    MANAGE_BUSINESS_AREA_DATA_FIRST_ROW_IS_HEADER_CHECKBOX: "manage-business-area-data-first-row-is-header-checkbox",
    MANAGE_BUSINESS_AREA_DATA_APPEND_DATA_OPTION: "manage-business-area-data-append-the-data-option",
    MANAGE_BUSINESS_AREA_DATA_CANCEL_BUTTON: "manage-business-area-data-cancel-button",
    MANAGE_BUSINESS_AREA_DATA_SAVE_BUTTON: "manage-business-area-data-save-button",
    MANAGE_BUSINESS_AREA_DATA_DOMAIN_DATA_PREVIEW_LIST: "manage-business-area-data-domain-data-preview-list",

    // RoleUserList
    ADD_ROLE_USER_BUTTON: "add-role-user-button",

    // Schema Page
    CREATE_NEW_SCHEMA_BUTTON: "create-new-schema-button",
    CREATE_NEW_SCHEMA_FROM_FILE_BUTTON: "create-new-schema-from-file-button",
    CREATE_NEW_SCHEMA_MANUALLY_BUTTON: "create-new-schema-manually-button",
    CREATE_NEW_SCHEMA_CLONE_BUTTON: "create-new-schema-clone-button",
    CREATE_NEW_SCHEMA_FROM_SYSTEM_CONNECTION_BUTTON: "create-new-schema-from-system-connection-button",

    // Schema Upload
    UPLOAD_SCHEMA_FILE_INPUT: "upload-schema-file-input",
    UPLOAD_SCHEMA_FIRST_ROW_CHECKBOX: "upload-schema-first-row-checkbox",
    UPLOAD_SCHEMA_RADIO_AUTO_DETECT: "upload-schema-radio-auto-detect",
    UPLOAD_SCHEMA_RADIO_STACK_DEFINITION: "upload-schema-radio-stack-definition",
    UPLOAD_SCHEMA_AUTODETECT_DELIMITER_DROPDOWN: "upload-schema-autodetect-delimiter-dropdown",
    UPLOAD_SCHEMA_CUSTOM_DELIMITER_INPUT: "upload-schema-custom-delimiter-input",
    UPLOAD_SCHEMA_CANCEL_BUTTON: "upload-schema-cancel-button",
    UPLOAD_SCHEMA_NEXT_BUTTON: "upload-schema-next-button",
    UPLOAD_SCHEMA_FILE_INPUT_ICON_BUTTON: "upload-schema-file-input-icon-button",

    // Schema auto-configure from sample data (PRE-2716)
    AUTO_CONFIGURE_CHECKBOX: "auto-configure-checkbox",
    AUTO_CONFIGURE_SAMPLE_SIZE: "auto-configure-sample-size",
    SUGGESTION_REVIEW: "schema-suggestion-review",
    SUGGESTION_ACCEPT_ALL: "suggestion-accept-all",
    SUGGESTION_REJECT_ALL: "suggestion-reject-all",
    SUGGESTION_REVIEW_CONTINUE: "suggestion-review-continue",
    SUGGESTION_REVIEW_CANCEL: "suggestion-review-cancel",

    // Manage Schema Model
    MANAGE_SCHEMA_MODEL_NAME_INPUT: "manage-schema-model-name-input",
    MANAGE_SCHEMA_MODEL_DESCRIPTION_INPUT: "manage-schema-model-description-input",
    MANAGE_SCHEMA_MODEL_CANCEL_BUTTON: "manage-schema-model-cancel-button",
    MANAGE_SCHEMA_MODEL_SAVE_AS_DRAFT_BUTTON: "manage-schema-model-save-as-draft-button",
    MANAGE_SCHEMA_MODEL_SAVE_PUBLISH_BUTTON: "manage-schema-model-save-publish-button",
    MANAGE_SCHEMA_MODEL_EXPORT_BUTTON: "manage-schema-model-export-button",
    MANAGE_SCHEMA_MODEL_PROMPT_PROCEED_BUTTON: "manage-schema-model-prompt-proceed-button",

    // Schema Model List
    SCHEMA_LIST_EDIT_BUTTON: "schema-list-edit-button",
    SCHEMA_LIST_VIEW_BUTTON: "schema-list-view-button",
    SCHEMA_LIST_CHANGE_HISTORY_BUTTON: "schema-list-change-history-button",
    SCHEMA_LIST_VISUALISE_RELATIONSHIPS_BUTTON: "schema-list-visualise-relationships-button",
    SCHEMA_LIST_DELETE_BUTTON: "schema-list-delete-button",
    SCHEMA_LIST_SHARING_CHECKBOX: "schema-list-sharing-checkbox",
    SCHEMA_LIST_TABLE: "schema-list-table",

    // Schema Model Field List
    SCHEMA_FIELD_ISPRIMARY_CHECKBOX: "schema-field-isprimary-checkbox",
    SCHEMA_FIELD_ISSORTKEY_CHECKBOX: "schema-field-issortkey-checkbox",
    SCHEMA_FIELD_ISACTIVE_CHECKBOX: "schema-field-isactive-checkbox",
    SCHEMA_FIELD_ISREQUIRED_CHECKBOX: "schema-field-isrequired-checkbox",
    SCHEMA_FIELD_NAME_INPUT: "schema-field-name-input",
    SCHEMA_FIELD_DESCRIPTION_INPUT: "schema-field-description-input",
    SCHEMA_FIELD_DATATYPE_SELECT: "schema-field-datatype-select",
    SCHEMA_FIELD_DELETE_BUTTON: "schema-field-delete-button",
    SCHEMA_FIELD_ADD_BUTTON: "schema-field-add-button",
    SCHEMA_FIELD_TABLE: "schema-field-table",

    //Schema create by cloning
    SCHEMA_CREATE_NEW_SCHEMA_CLONE_SCHEMA_TREE: "schema-create-new-schema-clone-schema-tree",
    SCHEMA_CREATE_NEW_SCHEMA_CLONE_SCHEMA_NAME_INPUT: "schema-create-new-schema-clone-schema-name-input",
    SCHEMA_CREATE_NEW_SCHEMA_CLONE_SCHEMA_DESC_INPUT: "schema-create-new-schema-clone-schema-desc-input",
    SCHEMA_CREATE_NEW_SCHEMA_CLONE_SCHEMA_CREATE_BUTTON: "schema-create-new-schema-clone-schema-create-button",

    //Manage Dataset
    DATASET_MANAGE_DATASET_NAME_INPUT: "manage-dataset-name-input",
    DATASET_MANAGE_DATASET_DESCRIPTION_INPUT: "manage-dataset-description-input",
    DATASET_MANAGE_DATASET_CONNECT_TO_A_SYSTEM_BUTTON: "manage-dataset-connect-to-a-system-button",
    DATASET_MANAGE_DATASET_LOAD_DATA_FILE_INPUT: "manage-dataset-load-data-file-input",
    DATASET_MANAGE_DATASET_CANCEL_BUTTON: "manage-dataset-cancel-button",
    DATASET_MANAGE_DATASET_SAVE_BUTTON: "manage-dataset-save-button",
    DATASET_MANAGE_DATASET_ADD_DATA_BUTTON: "manage-dataset-add-data-button",
    DATASET_MANAGE_DATASET_EXPORT_BUTTON: "manage-dataset-export-button",
    DATASET_MANAGE_DATASET_REQUEST_VERIFICATION_BUTTON: "manage-dataset-request-verification-button",
    DATASET_RECORDS_TABLE: "dataset-records-table",
    DATASET_RECORD_FORM: "dataset-record-form",
    DATASET_RECORD_COMMENTS_INDICATOR: "dataset-record-comments-indicator",
    DATASET_RECORD_ANNOTATIONS_INDICATOR: "dataset-record-annotations-indicator",
    DATASET_VERIFICATION_MODAL: "dataset-verification-modal",
    DATASET_VERIFICATION_ATTRIBUTE: "dataset-verification-attribute",
    DATASET_VERIFICATION_CONSENT_CHECKBOX: "dataset-verification-consent-checkbox",
    DATASET_VERIFICATION_CONFIRMATION_INPUT: "dataset-verification-confirmation-input",
    DATASET_VERIFICATION_SUBMIT_BUTTON: "dataset-verification-submit-button",
    DATASET_VERIFICATION_CONFIRMATION_ERROR: "dataset-verification-confirmation-error",
    DATASET_BATCH_UPLOAD_HISTORY_BUTTON: "dataset-batch-upload-history-button",

    //Dataset List
    DATASET_LIST_TABLE: "dataset-list-table",
    DATASET_LIST_EDIT_BUTTON: "dataset-list-edit-button",
    DATASET_LIST_VIEW_BUTTON: "dataset-list-view-button",
    DATASET_LIST_HISTORY_BUTTON: "dataset-list-history-button",
    DATASET_LIST_DELETE_BUTTON: "dataset-list-delete-button",
    DATASET_LIST_CREATE_NEW_DATASET_BUTTON: "dataset-list-create-new-dataset-button",
    DATASET_LIST_REVIEW_QUEUE_BUTTON: "dataset-list-review-queue-button",
    DATASET_LIST_INDEX_DATASET_DATABASETWOTONE: "dataset-list-index-dataset-databasetwotone",
    DATASET_LIST_EXPORT_DROPDOWN: "dataset-list-export-dropdown",
    DATASET_LIST_EXPORT_TO_FILE: "dataset-list-export-to-file",
    DATASET_LIST_EXPORT_TO_DESTINATION: "dataset-list-export-to-destination",
    DATASET_LIST_CLOUD_DOWNLOAD: "dataset-list-cloud-download",

    //Dataset Export
    DATASET_EXPORT_CANCEL_BUTTON: "dataset-export-cancel-button",
    DATASET_EXPORT_EXPORT_BUTTON: "dataset-export-export-button",

    //Dataset Insights
    DATASET_INSIGHTS_TABLE: "dataset-insights-table",

    // Min/Max Length property
    SCHEMA_MAX_LENGTH_PROPERTY_INPUT: "schema-max-length-property-input",
    SCHEMA_MIN_LENGTH_PROPERTY_INPUT: "schema-min-length-property-input",

    // Multi Value property
    SCHEMA_MULTIVALUE_PROPERTY_CHECKBOX: "schema-multivalue-property-checkbox",

    // PII property
    SCHEMA_PII_PROPERTY_CHECKBOX: "schema-pii-property-checkbox",

    // Classifier property
    SCHEMA_CLASSIFIERS_PROPERTY_SELECT: "schema-classifier-property-select",

    //Users Page
    USERS_USERSLIST_TABLE: "users-userlist-table",
    USERS_ADD_USER_BUTTON: "users-add-user-button",
    USERS_USERSLIST_EDIT_BUTTON: "users-userlist-edit-button",
    USERS_USERSLIST_VIEW_BUTTON: "users-userlist--view-button",
    USERS_USERSLIST_HISTORY_BUTTON: "users-userlist-history-button",
    USERS_USERSLIST_ACTIVE_SWITCH: "users-userlist-active-switch",
    USERS_SAVE_BUTTON: "users-save-button",
    USERS_CANCEL_BUTTON: "users-cancel-button",
    USERS_RESETPASSWORD_BUTTON: "users-resetpassword-button",
    USERS_EMAIL_INPUT: "users-email-input",
    USERS_FIRST_NAME_INPUT: "users-first-name-input",
    USERS_LAST_NAME_INPUT: "users-last-name-input",

    //Data Tags

    DATATAGS_DATATAGLIST_TABLE: "datatags-datataglist-table",
    DATATAGS_ADD_DATATAG_BUTTON: "datatags-add-datatag-button",
    DATATAGS_DATATAGLIST_EDIT_BUTTON: "datatags-datataglist-edit-button",
    DATATAGS_DATATAGLIST_VIEW_BUTTON: "datatags-datataglist-view-button",
    DATATAGS_DATATAGLIST_HISTORY_BUTTON: "datatags-datataglist-history-button",
    DATATAGS_DATATAGLIST_DELETE_BUTTON: "datatags-datataglist-delete-button",
    DATATAGS_DATATAG_SAVE_BUTTON: "datatags-save-button",
    DATATAGS_DATATAG_CANCEL_BUTTON: "datatags-cancel-button",
    DATATAGS_DATATAG_BUSINESSAREA_SELECT: "datatags-datatag-businessarea-select",
    DATATAGS_DATATAG_NAME_INPUT: "datatags-datatag-name-input",
    DATATAGS_DATATAG_DESCRIPTION_INPUT: "datatags-datatag-description-input",

    //Roles List
    ROLES_LIST_EDIT_BUTTON: "roles-list-edit-button",
    ROLES_LIST_VIEW_BUTTON: "roles-list-view-button",
    ROLES_LIST_HISTORY_BUTTON: "roles-list-history-button",
    ROLES_LIST_ACTIVE_SWITCH: "roles-list-active-switch",
    ROLES_LIST_DELETE_BUTTON: "roles-list-delete-button",
    ROLES_LIST_ADD_ROLE_BUTTON: "roles-list-add-role-button",
    ROLES_LIST_TABLE: "roles-list-table",

    //Manage Roles
    ROLES_MANAGE_ROLE_NAME_INPUT: "role-manage-role-name-input",
    ROLES_MANAGE_ROLE_DESCRIPTION_INPUT: "role-manage-role-description-input",
    ROLES_MANAGE_ROLE_TAB_PERMISSIONS_TAB: "role-manage-role-tab-permission-tab",
    ROLES_MANAGE_ROLE_TAB_USERS_TAB: "role-manage-role-tab-users-tab",
    ROLES_MANAGE_ROLE_TAB_CREDENTIALS_TAB: "role-manage-role-tab-credentials-tab",
    ROLES_MANAGE_ROLE_CANCEL_BUTTON: "role-manage-role-cancel-button",
    ROLES_MANAGE_ROLE_SAVE_BUTTON: "role-manage-role-save-button",
    ROLES_MANAGE_ROLE_TABLE: "role-manage-role-table",

    //Role Permission List
    ROLES_PERMISSIONS_LIST_PERMISSION_NAME_SELECT: "roles-permission-list-permission-name-select",
    ROLES_PERMISSIONS_LIST_PERMISSION_DESCRIPTION_INPUT: "roles-permission-list-permission-description-input",
    ROLES_PERMISSIONS_LIST_ACTIVE_CHECK: "roles-permission-list-active-check",
    ROLES_PERMISSIONS_LIST_CAN_ADD_CHECK: "roles-permission-list-can-add-check",
    ROLES_PERMISSIONS_LIST_CAN_VIEW_CHECK: "roles-permission-list-can-view-check",
    ROLES_PERMISSIONS_LIST_CAN_EDIT_CHECK: "roles-permission-list-can-edit-check",
    ROLES_PERMISSIONS_LIST_CAN_DELETE_CHECK: "roles-permission-list-can-delete-check",
    ROLES_PERMISSIONS_LIST_OTHER_ACTIONS_CHECK_GROUP: "roles-permission-list-other-actions-check-group",
    ROLES_PERMISSIONS_LIST_PERMISSION_DELETE_BUTTON: "roles-permission-list-permission-delete-button",
    ROLES_PERMISSIONS_LIST_ADD_PERMISSION_BUTTON: "roles-permission-list-add-permission-button",
    ROLES_PERMISSIONS_LIST_TABLE: "roles-permission-list-table",

    //Role Users
    ROLES_USER_LIST_USER_ID_SELECT: "role-user-list-user-id-select",
    ROLES_USER_LIST_USER_ACTIVE_CHECK: "role-user-list-user-active-check",
    ROLES_USER_LIST_USER_DELETE_BUTTON: "role-user-list-user-delete-button",
    ROLES_USER_LIST_ADD_USER_BUTTON: "role-user-list-add-user-button",
    ROLES_USER_LIST_TABLE: "role-user-list-table",

    //Role Credentials
    ROLES_CREDENTIALS_LIST_NAME_SELECT: "role-credentials-list-name-select",
    ROLES_CREDENTIALS_LIST_ACTIVE_CHECK: "role-credentials-list-active-check",
    ROLES_CREDENTIALS_LIST_DELETE_BUTTON: "role-credentials-list-delete-button",
    ROLES_CREDENTIALS_LIST_ADD_CREDENTIAL_BUTTON: "role-credentials-list-add-credential-button",
    ROLES_CREDENTIALS_LIST_TABLE: "role-credentials-list-table",

    //System Connection List
    SYSTEM_CONNECTION_LIST_TABLE: "system-connection-list-table",
    SYSTEM_CONNECTION_LIST_EDIT_BUTTON: "system-connection-list-edit-button",
    SYSTEM_CONNECTION_LIST_VIEW_BUTTON: "system-connection-list-view-button",
    SYSTEM_CONNECTION_LIST_HISTORY_BUTTON: "system-connection-list-history-button",
    SYSTEM_CONNECTION_LIST_ACTIVE_SWITCH: "system-connection-list-active-switch",
    SYSTEM_CONNECTION_LIST_DELETE_BUTTON: "system-connection-list-delete-button",
    SYSTEM_CONNECTION_LIST_ADD_BUTTON: "system-connection-list-add-button",

    //System Connection AWS S3 List
    SYSTEM_CONNECTION_AWS_S3_LIST_TABLE: "system-connection-aws-s3-list-table-button",
    SYSTEM_CONNECTION_AWS_S3_LIST_EDIT_BUTTON: "system-connection-aws-s3-list-edit-button",
    SYSTEM_CONNECTION_AWS_S3_LIST_VIEW_BUTTON: "system-connection-aws-s3-list-view-button",
    SYSTEM_CONNECTION_AWS_S3_LIST_HISTORY_BUTTON: "system-connection-aws-s3-list-history-button",
    SYSTEM_CONNECTION_AWS_S3_LIST_DELETE_BUTTON: "system-connection-aws-s3-list-delete-button",
    SYSTEM_CONNECTION_AWS_S3_LIST_ADD_BUTTON: "system-connection-aws-s3-list-add-button",
    SYSTEM_CONNECTION_AWS_S3_LIST_ACTIVE_SWITCH: "system-connection-aws-s3-list-active-switch",
    //System Connection Selector

    //System Keys
    //System Connection AWS S3 List
    SYSTEM_KEYS_LIST_TABLE: "system-keys-list-table-button",
    SYSTEM_KEYS_LIST_EDIT_BUTTON: "system-keys-list-edit-button",
    SYSTEM_KEYS_LIST_VIEW_BUTTON: "system-keys-list-view-button",
    SYSTEM_KEYS_LIST_HISTORY_BUTTON: "system-keys-list-history-button",
    SYSTEM_KEYS_LIST_DELETE_BUTTON: "system-keys-list-delete-button",
    SYSTEM_KEYS_LIST_ADD_BUTTON: "system-keys-list-add-button",
    //Manage
    SYSTEM_KEYS_MANAGE_NAME_INPUT: "system-keys-manage-name-input",
    SYSTEM_KEYS_MANAGE_DESCRIPTION_INPUT: "system-keys-manage-description-input",
    SYSTEM_KEYS_MANAGE_TYPE_SELECT: "system-keys-manage-type-select",
    SYSTEM_KEYS_MANAGE_API_KEY_INPUT: "system-keys-manage-api-key-input",
    SYSTEM_KEYS_MANAGE_CANCEL_BUTTON: "system-keys-manage-cancel-button",
    SYSTEM_KEYS_MANAGE_SAVE_BUTTON: "system-keys-manage-save-button",
    SYSTEM_KEYS_MANAGE_TABLE: "system-keys-manage-table",

    //API Key List
    API_KEY_LIST_TABLE: "api-key-list-table",
    API_KEY_LIST_EDIT_BUTTON: "api-key-list-edit-button",
    API_KEY_LIST_VIEW_BUTTON: "api-key-list-view-button",
    API_KEY_LIST_HISTORY_BUTTON: "api-key-list-history-button",
    API_KEY_LIST_DELETE_BUTTON: "api-key-list-delete-button",
    API_KEY_LIST_ADD_BUTTON: "api-key-list-add-button",
    API_KEY_LIST_ACTIVE_SWITCH: "api-key-list-active-switch",
    API_KEY_LIST_STATUS_TAG: "api-key-list-status-tag",
    //Manage
    API_KEY_MANAGE_NAME_INPUT: "api-key-manage-name-input",
    API_KEY_MANAGE_DESCRIPTION_INPUT: "api-key-manage-description-input",
    API_KEY_MANAGE_EXPIRES_AT_INPUT: "api-key-manage-expires-at-input",
    API_KEY_MANAGE_KEY_ID_INPUT: "api-key-manage-key-id-input",
    API_KEY_MANAGE_SECRET_INPUT: "api-key-manage-secret-input",
    API_KEY_MANAGE_KEY_ID_COPY_INPUT: "api-key-manage-key-id-copy-input",
    API_KEY_SECRET_MODAL: "api-key-secret-modal",
    API_KEY_SECRET_MODAL_COPY_INPUT: "api-key-secret-modal-copy-input",
    API_KEY_MANAGE_CANCEL_BUTTON: "api-key-manage-cancel-button",
    API_KEY_MANAGE_SAVE_BUTTON: "api-key-manage-save-button",

    //CDC
    CDC_LIST_TABLE: "cdc-list-table-button",
    CDC_LIST_EDIT_BUTTON: "cdc-list-edit-button",
    CDC_LIST_VIEW_BUTTON: "cdc-list-view-button",
    CDC_LIST_DELETE_BUTTON: "cdc-list-delete-button",
    CDC_LIST_ADD_BUTTON: "cdc-list-add-button",
    CDC_LIST_ACTIVE_SWITCH: "cdc-list-active-switch",
    //Manage
    CDC_MANAGE_NAME_INPUT: "cdc-manage-name-input",
    CDC_MANAGE_DESCRIPTION_INPUT: "cdc-manage-description-input",
    CDC_MANAGE_OBJECTS_SELECT: "cdc-manage-objects-select",
    CDC_MANAGE_EVENTS_SELECT: "cdc-manage-events-select",
    CDC_MANAGE_DESTINATION_SELECT: "cdc-manage-destination-select",
    CDC_MANAGE_KINESIS_REGION_INPUT: "cdc-manage-kinesis-region-input",
    CDC_MANAGE_KINESIS_STREAM_ARN_INPUT: "cdc-manage-kinesis-stream-arm-input",
    CDC_MANAGE_KINESIS_ROLE_ARN_INPUT: "cdc-manage-kinesis-role-input",
    CDC_MANAGE_CANCEL_BUTTON: "cdc-manage-cancel-button",
    CDC_MANAGE_SAVE_BUTTON: "cdc-manage-save-button",

    //common objects
    COMMON_OBJECTS_EVENT_LIST_TABLE: "common-objects-event-list-table",
    COMMON_OBJECTS_REVISIONS_LIST_TABLE: "common-objects-revesions-list-table",

    // Tenancy Customization
    TENANCY_CUSTOMIZATION_TITLE_TEXT: "tenancy-customization-title-text",
    TENANCY_CUSTOMIZATION_TEXT_INPUT_1: "tenancy-customization-text-input-1",
    TENANCY_CUSTOMIZATION_TEXT_INPUT_2: "tenancy-customization-text-input-2",
    TENANCY_CUSTOMIZATION_IMAGE_INPUT: "tenancy-customization-image-input",
    TENANCY_CUSTOMIZATION_IMAGE_PREVIEW: "tenancy-customization-image-preview",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_1: "tenancy-customization-color-palette-1",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_2: "tenancy-customization-color-palette-2",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_3: "tenancy-customization-color-palette-3",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_4: "tenancy-customization-color-palette-4",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_5: "tenancy-customization-color-palette-5",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_6: "tenancy-customization-color-palette-6",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_7: "tenancy-customization-color-palette-7",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_8: "tenancy-customization-color-palette-8",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_9: "tenancy-customization-color-palette-9",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_10: "tenancy-customization-color-palette-10",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_11: "tenancy-customization-color-palette-11",
    TENANCY_CUSTOMIZATION_COLOR_PALETTE_12: "tenancy-customization-color-palette-12",
    TENANCY_CUSTOMIZATION_SUBMIT_BUTTON: "tenancy-customization-submit-button",
    TENANCY_CUSTOMIZATION_CANCEL_BUTTON: "tenancy-customization-cancel-button",
    TENANCY_CUSTOMIZATION_RESET_BUTTON: "tenancy-customization-reset-button",
    TENANCY_CUSTOMIZATION_DELETE_IMAGE_BUTTON: "tenancy-customization-delete-image-button",
    TENANCY_CUSTOMIZATION_GENERATE_PREVIEW_BUTTON: "tenancy-customization-generate-preview-button",
    TENANCY_CUSTOMIZATION_PREVIEW_HEADER_FOOTER: "tenancy-customization-preview-header-footer",
    TENANCY_CUSTOMIZATION_PREVIEW_NAVIGATION_BAR: "tenancy-customization-preview-navigation-bar",
    TENANCY_CUSTOMIZATION_PREVIEW_SELECTED_HEADER: "tenancy-customization-preview-selected-header",
    TENANCY_CUSTOMIZATION_PREVIEW_PRIMARY_BUTTONS: "tenancy-customization-preview-primary-buttons",
    TENANCY_CUSTOMIZATION_PREVIEW_FORM_BACKGROUND: "tenancy-customization-preview-form-background",
    TENANCY_CUSTOMIZATION_PREVIEW_SECONDARY_BUTTONS: "tenancy-customization-preview-secondary-buttons",
    TENANCY_CUSTOMIZATION_PREVIEW_SELECTED_ROW: "tenancy-customization-preview-selected-row",
    TENANCY_CUSTOMIZATION_PREVIEW_LABEL_COLOR: "tenancy-customization-preview-label-color",

    //Search
    SEARCH_TABS_ADVANCED_TAB: "search-tabs-build-tab",
    SEARCH_TABS_BUILD_TAB: "search-tabs-ask-tab",
    SEARCH_TABS_ASK_TAB: "search-tabs-ask-tab",
    SEARCH_BUSINESS_AREA_SELECT: "search-business-area-select",
    SEARCH_SCHEMA_SELECT: "search-schema-select",
    SEARCH_DATASET_SELECT: "search-dataset-select",
    SEARCH_CRITERIA_INPUT: "search-criteria-input",
    SEARCH_SEARCH_BUTTON: "search-search-button",
    SEARCH_SEARCH_CLEAR_BUTTON: "search-search-clear-button",
    SEARCH_HIDE_BUILDER_BUTTON: "search-hide-builder-button",
    SEARCH_BUILDER_AND_BUTTON: "search-builder-and-button",
    SEARCH_BUILDER_RULE_BUTTON: "search-builder-rule-button",
    SEARCH_BUILDER_GROUP_BUTTON: "search-builder-group-button",
    SEARCH_BUILDER_TO_ADVANCED_SEARCH_BUTTON: "search-builder-to-advanced-search-button",
    SEARCH_BUILDER_CLEARALL_BUTTON: "search-builder-clearall-button",
    SEARCH_BUILDER_SEARCH_BUTTON: "search-builder-search-button",
    SEARCH_BUILDER_RULE_PARAM1_SELECT: "search-builder-rule-param1-select",
    SEARCH_BUILDER_RULE_OPERATOR_SELECT: "search-builder-rule-operator-select",
    SEARCH_BUILDER_RULE_SEARCHTEXT_INPUT: "search-builder-rule-searchtext-input",
    SEARCH_BUILDER_RULE_DELETE_BUTTON: "search-builder-rule-delete-button",
    SEARCH_BUILDER_GROUP_DELETE_BUTTON: "search-builder-group-delete-button",
    SEARCH_SHOW_SENSITIVE_DATA_CHECKBOX: "search-show-sensitive-data-checkbox",

    //Syndication
    SYNDICATION_SOURCE_MANAGE_NAME_INPUT: "syndication-source-manage-name-input",
    SYNDICATION_SOURCE_MANAGE_PURPOSE_INPUT: "syndication-source-manage-purpose-input",
    SYNDICATION_SOURCE_MANAGE_BUSINESS_AREA_DESC_INPUT: "syndication-source-manage-business-area-desc-input",
    SYNDICATION_SOURCE_MANAGE_SCHEMA_DESC_INPUT: "syndication-source-manage-schema-desc-input",
    SYNDICATION_SOURCE_MANAGE_SCHEDULING_INTERVAL_INPUT: "syndication-source-manage-scheduling-interval-input",
    SYNDICATION_SOURCE_MANAGE_BUSINESS_AREA_SELECT: "syndication-source-manage-business-area-select",
    SYNDICATION_SOURCE_MANAGE_SCHEMA_SELECT: "syndication-source-manage-schema-select",
    SYNDICATION_SOURCE_MANAGE_DATASET_SELECT: "syndication-source-manage-dataset-select",
    SYNDICATION_SOURCE_MANAGE_SCHEDULING_UNIT_SELECT: "syndication-source-manage-scheduling-unit-select",
    SYNDICATION_SOURCE_MANAGE_VALID_FROM_CALENDAR: "syndication-source-manage-valid-from-calendar",
    SYNDICATION_SOURCE_MANAGE_VALID_UNTIL_CALENDAR: "syndication-source-manage-valid-until-calendar",
    SYNDICATION_SOURCE_MANAGE_ENABLED_SWITCH: "syndication-source-manage-enabled-switch",
    SYNDICATION_SOURCE_MANAGE_CANCEL_BUTTON: "syndication-source-manage-cancel-button",
    SYNDICATION_SOURCE_MANAGE_SAVE_BUTTON: "syndication-source-manage-save-button",
    SYNDICATION_SOURCE_LIST_TABLE: "syndication-source-list-table",
    SYNDICATION_SOURCE_LIST_ADD_BUTTON: "syndication-source-list-add-button",
    SYNDICATION_SOURCE_LIST_EDIT_BUTTON: "syndication-source-list-edit-button",
    SYNDICATION_SOURCE_LIST_VIEW_BUTTON: "syndication-source-list-view-button",
    SYNDICATION_SOURCE_LIST_DELETE_BUTTON: "syndication-source-list-delete-button",

    //Duplicate Search
    DUPLICATE_SEARCH_CLUSTERED_VIEW_BUTTON: "duplicate-search-clustered-view-button",
    DUPLICATE_SEARCH_SEQUENCED_VIEW_BUTTON: "duplicate-search-sequenced-view-button",
    DUPLICATE_SEARCH_CLUSTERED_VIEW_CONTAINER: "duplicate-search-clustered-view-container",
    DUPLICATE_SEARCH_CLUSTERED_VIEW_DROPDOWN: "duplicate-search-clustered-view-dropdown",
    DUPLICATE_SEARCH_CONFIG_CONTAINER: "duplicate-search-config-container",
    DUPLICATE_SEARCH_CONFIG_NAME_INPUT: "duplicate-search-config-name-input",
    DUPLICATE_SEARCH_CONFIG_DESCRIPTION_INPUT: "duplicate-search-config-description-input",
    DUPLICATE_SEARCH_CONFIG_BUSINESS_AREA_SELECT: "duplicate-search-config-business-area-select",
    DUPLICATE_SEARCH_CONFIG_SCHEMA_SELECT: "duplicate-search-config-schema-select",
    DUPLICATE_SEARCH_CONFIG__DATASET_SELECT: "duplicate-search-config--dataset-select",
    DUPLICATE_SEARCH_CONFIG_TAG_SEARCH_SELECT: "duplicate-search-config-tag-search-select",
    DUPLICATE_SEARCH_CONFIG_SEARCH_BUTTON: "duplicate-search-config-search-button",
    DUPLICATE_SEARCH_CONFIG_CLOSE_BUTTON: "duplicate-search-config-close-button",
    DUPLICATE_SEARCH_CONFIG_COLLAPSE_BUTTON: "duplicate-search-config-collapse-button",
    DUPLICATE_SEARCH_CONFIG_LIST_TABLE: "duplicate-search-config-list-table",
    DUPLICATE_SEARCH_CONFIG_LIST_STATUS: "duplicate-search-config-list-status",
    DUPLICATE_SEARCH_CONFIG_LIST_VIEW_DATA_BUTTON: "duplicate-search-config-list-view-data-button",
    DUPLICATE_SEARCH_CONFIG_LIST_RUN_JOB_AGAIN_BUTTON: "duplicate-search-config-list-run-job-again-button",
    DUPLICATE_SEARCH_CONFIG_LIST_CANCEL_JOB_BUTTON: "duplicate-search-config-list-cancel-job-button",
    DUPLICATE_SEARCH_CONFIG_LIST_DELETE_BUTTON: "duplicate-search-config-list-delete-button",
    DUPLICATE_SEARCH_CONFIG_LIST_BACK_BUTTON: "duplicate-search-config-list-back-button",

    // Duplicate DataObject
    DUPLICATE_DATAOBJECT_SHARE_BUTTON: "duplicate-dataobject-share-button",
    DUPLICATE_DATAOBJECT_VIEW_BUTTON: "duplicate-dataobject-view-button",
    DUPLICATE_DATAOBJECT_TABLE_LIST: "duplicate-dataobject-table-list",
    DUPLICATE_DATAOBJECT_CONTAINER: "duplicate-dataobject-container",

    RECENT_LIST_SCHEMA_EDIT_BUTTON: "recent-list-schema-edit-button",
    RECENT_LIST_SCHEMA_VIEW_BUTTON: "recent-list-schema-view-button",
    RECENT_LIST_SCHEMA_TABLE: "recent-list-schema-table",

    RECENT_LIST_DATASET_TABLE: "recent-list-dataset-table",
    RECENT_LIST_DATASET_EDIT_BUTTON: "recent-list-dataset-edit-button",
    RECENT_LIST_DATASET_VIEW_BUTTON: "recent-list-dataset-view-button",

    RECENT_LIST_JOBS_TABLE: "recent-list-jobs-table",

    // Components
    COMPONENT_ATOM_LOADINGOVERLAY: "cy-component-atom-loadingOverlay",
    COMPONENT_ATOM_SLIDEOUTMENU: "cy-component-atom-slideoutMenu",

    // Admin Console
    ADMIN_CONSOLE_TENANT_LIST: "admin-console-tenant-list",
    ADMIN_CONSOLE_TENANT_RUNNINGJOB_LIST: "admin-console-tenant-runningjob-list",

    // Pipeline Builder
    PIPELINE_OPEN_BUTTON: "pipeline-open-button",
    PIPELINE_CLOSE_BUTTON: "pipeline-close-button",
    PIPELINE_HEADER: "pipeline-header",
    PIPELINE_EMPTY_STATE: "pipeline-empty-state",
    PIPELINE_ADD_TRANSFORM_BUTTON: "pipeline-add-transform-button",
    PIPELINE_CATALOG_LIST: "pipeline-catalog-list",
    PIPELINE_CATALOG_ITEM: "pipeline-catalog-item",
    PIPELINE_STEP_LIST: "pipeline-step-list",
    PIPELINE_STEP_ITEM: "pipeline-step-item",
    PIPELINE_STEP_DELETE: "pipeline-step-delete",
    PIPELINE_CONFIGURATOR: "pipeline-configurator",
    PIPELINE_PREVIEW_BUTTON: "pipeline-preview-button",
    PIPELINE_SAVE_BUTTON: "pipeline-save-pipeline-button",
    PIPELINE_SAVE_NAME_INPUT: "pipeline-save-name-input",
    PIPELINE_SAVE_DESCRIPTION_INPUT: "pipeline-save-description-input",
    PIPELINE_SAVE_CONFIRM_BUTTON: "pipeline-save-confirm-button",
    PIPELINE_SAVE_CANCEL_BUTTON: "pipeline-save-cancel-button",
    PIPELINE_PREVIEW_MODAL: "pipeline-preview-modal",
    PIPELINE_PREVIEW_EXECUTE_BUTTON: "pipeline-preview-execute-button",
    PIPELINE_PREVIEW_CLOSE_BUTTON: "pipeline-preview-close-button",
    PIPELINE_SAVED_LIST: "pipeline-saved-list",
    PIPELINE_SAVED_ITEM: "pipeline-saved-item",
    PIPELINE_PIVOT_GROUP_BY: "pipeline-pivot-group-by",
    PIPELINE_PIVOT_ADD_AGGREGATION: "pipeline-pivot-add-aggregation",
    PIPELINE_PIVOT_OPERATION: "pipeline-pivot-operation",
    PIPELINE_PIVOT_SOURCE_COLUMN: "pipeline-pivot-source-column",
    PIPELINE_PIVOT_COMPARISON_TYPE: "pipeline-pivot-comparison-type",
    PIPELINE_PIVOT_SORT_COLUMN: "pipeline-pivot-sort-column",
    PIPELINE_PIVOT_SORT_DIRECTION: "pipeline-pivot-sort-direction",
    PIPELINE_PIVOT_SORT_COMPARISON_TYPE: "pipeline-pivot-sort-comparison-type",
    PIPELINE_PIVOT_OUTPUT_COLUMN: "pipeline-pivot-output-column",
};

export default CypressTestIds;
